<script setup>
  import {computed} from "vue";

  import {MedHoverCard} from "@pharma4u/medicheck-components";
  import {uniqBy} from "es-toolkit";
  import {map} from "es-toolkit/compat";

  defineOptions({
    name: "MedicationComponentIndicationDisplay",
  });

  const props = defineProps({
    indications: {
      type: Object,
      required: true,
    },
    indicationsUnknown: {
      type: Number,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    isDiscontinued: {
      type: Boolean,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  defineEmits(["openDialog"]);

  const maxIndicationRowLength = 28;

  const indicationMessage = computed(() => buildIndicationMessage());
  const hasDisplayMessage = computed(() => displayIndicationMessage.value.length > 0);

  const addContentDependingStyle = computed(() => {
    return {
      lineheight: isSingleLine,
      empty: isEmpty,
      disabled: props.disabled,
    };
  });

  const displayIndicationMessage = computed(() => {
    if (props.indicationsUnknown === 1) {
      return "Unbekannt";
    }

    return indicationMessage.value;
  });

  const buildIndicationMessage = () => {
    if (!props.indications?.length) {
      return "";
    }

    return map(
      uniqBy(props.indications, (item) => item.abdata_key_miv),
      (indication) => indication.name || indication.name_icdc,
    ).join(", ");
  };

  const isSingleLine = () => {
    return indicationMessage.value.length < maxIndicationRowLength;
  };

  const isEmpty = () => {
    return props.indications.length === 0;
  };
</script>

<template>
  <template v-if="showLabel">
    <p class="mb-1 pl-2 text-sm text-gray-500">Grund / Ind.</p>
  </template>

  <div
    id="indicationDiv"
    class="h-9 truncate border-b border-gray-300 py-2 pl-2 text-sm"
    :class="[addContentDependingStyle, {'border-dashed text-gray-500': disabled}]"
    :data-test="getTestId('indication-display')"
  >
    <button class="w-full text-left enabled:cursor-pointer" :disabled="disabled" @click="$emit('openDialog')">
      <template v-if="hasDisplayMessage">
        <MedHoverCard>
          <div class="truncate" :class="{'line-through': isDiscontinued}">{{ displayIndicationMessage }}</div>

          <template #content>
            <ul v-if="!indicationsUnknown" class="grid list-disc gap-1.5 pl-4 text-sm">
              <li v-for="indication in indications" :key="indication.id">
                {{ indication.name }}
              </li>
            </ul>
            <span v-else>Unbekannt</span>
          </template>
        </MedHoverCard>
      </template>

      <template v-else-if="disabled">
        <span />
      </template>

      <template v-else>
        <span class="text-gray-500">Bitte auswählen</span>
      </template>
    </button>
  </div>
</template>
